export default {
  contributorsTableWrapper: {
    '& .MuiTable-root': {
      minWidth: 0,
    },
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
  },
  avatarImage: {
    borderRadius: '50%',
    height: 40,
    objectFit: 'cover',
    width: 40,
  },
  avatar: {
    height: 40,
    width: 40,
  },
  fullName: {
    color: 'text.dark',
    fontSize: '14px',
    fontWeight: 500,
    ml: 1,
  },
  role: {
    color: 'text.grey.blue_1',
  },
  searchFieldWrapper: {
    mb: 3,
    width: '100%',
    '& .MuiFormControl-root': {
      width: '100%',
      '& .MuiInputBase-root': {
        width: '100%',
      },
    },
  },
};
